import Constants from "./Constants";
import DomainInfo from "./views/DomainInfo";
import BlogChoice from "./views/BlogChoice";
import MigrationDetails from "./views/MigrationDetails";
import Confirm from "./views/Confirm";
import Complete from "./views/Complete";

const viewMap = new Map();

viewMap.set(Constants.VIEW_DOMAIN_INFO, {
  comp: DomainInfo,
  view: Constants.VIEW_DOMAIN_INFO,
  desc: "Domain Name Information",
});

viewMap.set(Constants.VIEW_BLOG_CHOICE, {
  comp: BlogChoice,
  view: Constants.VIEW_BLOG_CHOICE,
  desc: "Blog Setup",
});

viewMap.set(Constants.VIEW_MIGRATION_DETAILS, {
  comp: MigrationDetails,
  view: Constants.VIEW_MIGRATION_DETAILS,
  desc: "Migration Details",
});

viewMap.set(Constants.VIEW_CONFIRM, {
  comp: Confirm,
  view: Constants.VIEW_CONFIRM,
  desc: "Review",
});

viewMap.set(Constants.VIEW_COMPLETE, {
  comp: Complete,
  view: Constants.VIEW_COMPLETE,
  desc: "Finish",
});

export default viewMap;
